/** Escape 메인/보조 계정 분리 — 프론트 공용 */

export const ESCAPE_ACCOUNT_FIELD_KEYS = [
  'entry_usdt_1',
  'leverage_info',
  'benefit_ratio',
  'single_tp_continue_mode',
  'double_benefit',
  'double_continue',
];

export const DEFAULT_ESCAPE_ACCOUNT_SETTINGS = {
  entry_usdt_1: 10,
  leverage_info: 20,
  benefit_ratio: 0.2,
  single_tp_continue_mode: 'disable',
  double_benefit: 0,
  double_continue: 'disable',
};

export function pickEscapeAccountFields(source = {}) {
  const out = {};
  ESCAPE_ACCOUNT_FIELD_KEYS.forEach((key) => {
    if (source[key] !== undefined) {
      out[key] = source[key];
    }
  });
  return out;
}
